import { getPostHogFeatureFlagClient } from "@/shared/lib/monitoring/telemetry-config"

export const ACTIVATION_SPRINT_FLAG = "first-session-activation-sprint"
export const ACTIVATION_SPRINT_MESSAGES_GOAL = 5

export type ActivationSprintVariant = "activation" | "control" | "unassigned"

interface PostHogWithFlags {
  getFeatureFlag: (key: string) => string | boolean | undefined
  get_distinct_id?: () => string
  onFeatureFlags?: (cb: () => void) => (() => void) | void
}

export function normalizeActivationSprintVariant(
  raw: string | boolean | undefined
): ActivationSprintVariant {
  if (
    raw === true ||
    raw === "test" ||
    raw === "variant" ||
    raw === "activation" ||
    raw === "activation_sprint"
  ) {
    return "activation"
  }
  if (raw === "control" || raw === false) return "control"
  return "unassigned"
}

export function getPostHogForActivationSprint(): PostHogWithFlags | null {
  return getPostHogFeatureFlagClient<PostHogWithFlags>()
}

export function getActivationSprintVariant(): ActivationSprintVariant {
  const ph = getPostHogForActivationSprint()
  if (!ph) return "unassigned"
  return normalizeActivationSprintVariant(ph.getFeatureFlag(ACTIVATION_SPRINT_FLAG))
}
